import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';

import PopupBox from './PopupBox.js';

import Form from 'react-bootstrap/Form';
import IntroPopup from './IntroPopup.js';


export default class About extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
        show: false
    };
  }



  render() {





      //handle the click on one of the buttons
      const handleClick = (e) => {

        this.setState({show: true})
        

    };



      //handle the click on one of the buttons
      const closeClick = (e) => {

        this.setState({show: false})
        

    };



    var box = <div></div>

    if(this.state.show == true)
    {
        box = <IntroPopup closeClick={closeClick}><p class="intro-popup">Terms and Conditions Apply was created by <a target="_blank" href="https://twitter.com/wklondon">@WKLondon</a>, <a target="_blank" href="https://twitter.com/jonplackett">@Jonplackett</a>, <a target="_blank" href="https://twitter.com/AlexBellos">@AlexBellos</a> and <a target="_blank" href="https://twitter.com/iam_adam">@iam_adam</a>. With inspiration from <a target="_blank" href="https://darkpatterns.org">darkpatterns.org</a>, <a target="_blank" href="https://reddit.com/r/darkpatterns">r/darkpatterns</a> and every website on the internet</p><Button value="1" onMouseDown={closeClick} className="m-1 start-button" variant="danger" size="lg">Got it</Button>
        </IntroPopup>
    }

    return (

        <div>
        <a onClick={handleClick}><img id="wk" src="./wk.png"></img></a>

          
        {box}

        </div>
    );
  }
}
